import {  
  SET_IS_EDIT,
  SET_VERSIONS, 
  SET_PROJECT_DETIAL_DATA, 
  SET_SUBTYPE,
  INIT_DATA,
} from "./types"; 
import ApiUtils from "../helper/ApiUtils";
import TimeUtils from "../helper/TimeUtils";
import StringUtils from "../helper/StringUtils";
import ArratDataUtils from "../helper/ArratDataUtils";
 
// 設定字幕判定要不要做秒數驗算
export const setTSubType = (project_tSubType) => async (dispatch) => {
  dispatch({
    type: SET_SUBTYPE,
    payload: project_tSubType,
  });
};
 
//取本地儲存
export const getGetProjectDetial_local = () =>async (dispatch) => {
  if (localStorage.projectListData) {
    const stringData = localStorage.getItem("projectListData");
    dispatch({
      type: SET_PROJECT_DETIAL_DATA,
      payload: JSON.parse(stringData),
    });
  }
};

//取得專案資料，不透過本地儲存
export const jsonData_nolocal =
  (videoFps, tProjectDetialId = 0, email = "") =>
  async (dispatch) => {
    /**
     * 一脈相承的json檔案
     * */
    // const jsonData = await ApiUtils.post_sql(`${ApiUtils.post_DetialJsonData}`,{
    //     tProjectDetialId:tProjectDetialId
    // });
    const jsonData = await ApiUtils.post_sql(
      `${ApiUtils.post_DetialJsonData_byProjectDetial_fId}`,
      {
        tProjectDetialId: tProjectDetialId,
      }
    );

    //return ;
    if (jsonData === null) {
      return;
    }
    if (jsonData.length === 0) {
      //新增一組 然後重整 

      //新增
      const jsonData = await ApiUtils.post_sql(
        `${ApiUtils.post_AddDetialJsonData_email}`,
        {
          tProjectDetialId: tProjectDetialId,
          jsonstring: JSON.stringify([
            [
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ],
          ]),
          email: email,
        }
      );

      ApiUtils.checkSaveIsSuccess(jsonData);

      window.location.reload();

      return;
    }

    if (JSON.stringify(jsonData) === "{}") {
      //沒有東西 空的 清空
      return;
    } else {
      //最新的Id
      const newestJson = jsonData[0];
      const fId = newestJson["fId"];

      //取得最新的ID 然後去拿資料
      let NewestDetialJsonData = await ApiUtils.post_sql(
        `${ApiUtils.get_DetialJsonDataStringByfID}`,
        {
          qfID: parseInt(fId, 10),
        }
      );
      NewestDetialJsonData = StringUtils.UnZipUploadFile(NewestDetialJsonData);

      // NewestDetialJsonData = NewestDetialJsonData['dataArry'];
      //console.log(NewestDetialJsonData);

      //檢察有沒有start end
      NewestDetialJsonData.map((data, index) => {
        const { In, Out } = data;
        if (data["start"] === undefined) {
          //沒有記錄到時間
          NewestDetialJsonData[index]["start"] =
            TimeUtils.stringConvertToSeconds(In, parseFloat(videoFps));
        }
        if (data["end"] === undefined) {
          //沒有記錄到時間
          NewestDetialJsonData[index]["end"] = TimeUtils.stringConvertToSeconds(
            Out,
            parseFloat(videoFps)
          );
        }
        // NewestDetialJsonData[index]["start"] = TimeUtils.stringConvertToSeconds(In,parseFloat(videoFps));
        // NewestDetialJsonData[index]["end"] = TimeUtils.stringConvertToSeconds(Out,parseFloat(videoFps));
      });

      //console.log(`取得初始資料 ${JSON.stringify(NewestDetialJsonData)}`)

      //const NewestDetialJsonData = JSON.parse(NewestDetialJsonResp);
      //let NewestDetialJsonData = NewestDetialJsonResp.replace(".", "");

      let jsonArray = [];
      if (Array.isArray(NewestDetialJsonData)) {
        //是陣列
        jsonArray = NewestDetialJsonData;
      } else {
        //不是陣列 要創一個新的
        jsonArray = [NewestDetialJsonData];
      }

      dispatch({
        type: INIT_DATA,
        payload: jsonData,
      });

      return jsonArray;
    }
  };

//目前是否是更新
export const setIsEdit = (isEdit) => async (dispatch) => {
  dispatch({
    type: SET_IS_EDIT,
    payload: isEdit,
  });
};
 

/**
 * 更新各版本資料
 * */
export const get_versionData = (tProjectDetialId) => async (dispatch) => {
  /**
   * 一脈相承的json檔案
   * */
  const jsonData = await ApiUtils.post_sql(
    `${ApiUtils.post_DetialJsonData_byProjectDetial_fId}`,
    {
      tProjectDetialId: tProjectDetialId,
    }
  );

  dispatch({
    type: SET_VERSIONS,
    payload: jsonData,
  });
};



// WEBPACK FOOTER //
// ./src/actions/subtypeActions.js